import { FormField, Select, SelectOption } from "@justworkshr/milo-form";
import { ChangeEventHandler, FocusEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { useGetCurrentMemberCompanyDirectoryMembersQuery } from "types/generated/operations";

type ManagerSelectFieldProps = {
  value?: string;
  error?: string;
  handleBlur?: FocusEventHandler<HTMLSelectElement>;
  handleChange?: ChangeEventHandler<HTMLSelectElement>;
  name: string;
};

export default function ManagerSelectField({
  value,
  error,
  name,
  handleBlur,
  handleChange,
}: ManagerSelectFieldProps) {
  const { t } = useTranslation();
  const { data, loading } = useGetCurrentMemberCompanyDirectoryMembersQuery();

  if (data) {
    const directoryMembers = data.currentMember.company.directoryMembers;

    return (
      <FormField name={name} label={t("Manager")} error={error}>
        <Select
          name={name}
          placeholder={t("Select manager")}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
        >
          <SelectOption value="">{t("No Manager")}</SelectOption>
          {directoryMembers.map((directoryMember) => {
            const label = directoryMember.deskTitle
              ? `${directoryMember.friendlyFullName} - ${directoryMember.deskTitle}`
              : directoryMember.friendlyFullName;

            return (
              <SelectOption
                value={directoryMember.uuid}
                key={directoryMember.uuid}
              >
                {label}
              </SelectOption>
            );
          })}
        </Select>
      </FormField>
    );
  } else {
    return (
      <FormField name={name} label={t("Manager")}>
        <Select
          name={name}
          placeholder={
            loading ? t("Loading managers...") : t("No managers found!")
          }
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          disabled
        />
      </FormField>
    );
  }
}
